module.exports = __webpack_public_path__ + "img/bespoke70_11.a42a0cda.jpg";